export default __webpack_public_path__ + "static/fabric-catalogue-search-buyer-view-286a9c73f6ed2dc2b00486de8d8f471e.png";